//region :: Imports ::
import React, {ReactElement, ReactNode} from 'react';
import MComponent from '../Toolkit/Components/Component';
import {MIcon, MOkIconName} from '../Toolkit/Icons';
import {DialogPositionType} from 'primereact/dialog';
import MDialog from '../Toolkit/Components/Controls/Dialog';
import MButton from '../Toolkit/Components/Controls/Button';

//endregion

/** */
type Props = {}

/** */
type State = {
    title?: string;
    message?: string | ReactNode;
    icon?: MIcon;
    position?: DialogPositionType;
    visible: boolean;
}

/** */
class MessageDialog extends MComponent<Props, State> {

    /** */
    public constructor(props: Props) {
        super(props);

        this.bindMethods();
        this.initializeState();

    }

    /** */
    private bindMethods(): void {
        this.dialog_onHide = this.dialog_onHide.bind(this);
        this.ok_Click = this.dialog_onHide.bind(this);
    }

    /** */
    private initializeState(): void {
        this.state = {visible: false};
    }

    /** */
    private dialog_onHide(): void {
        this.safeSetState((draft: State) => draft.visible = false);
    }

    /** */
    public show(title: string, message: string | ReactNode, icon?: MIcon, position?: DialogPositionType) {

        this.safeSetState((draft: State) => {

            draft.title = title;
            draft.message = message;
            draft.icon = icon;
            draft.position = position;
            draft.visible = true;

        });

    }

    private ok_Click(): void {
        this.safeSetState((draft: State) => {
            draft.visible = false;
        });
    }

    private getFooterTemplate(): ReactNode {
        return (
            <div>
                <MButton label="OK"
                         color="success"
                         icon={MOkIconName}
                         disabled={false}
                         onClick={this.ok_Click}/>
            </div>
        );
    }

    /** */
    public render(): ReactElement {

        return (
            <MDialog title={this.state.title ?? ''}
                     content={this.state.message}
                     icon={this.state.icon}
                     footer={this.getFooterTemplate()}
                     position={this.state.position}
                     canClose={false}
                     closeOnEscape={false}
                     visible={this.state.visible}
                     onHide={this.dialog_onHide}/>
        );

    }

}

export default MessageDialog;